import axiosBasicInstance from '../axiosConfig';
import { getAccessToken } from '../../utils/Function/commonFunction';

const googleSignup = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/signup/google`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const normalSignup = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/signup`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const signupBusiness = async (data) => {
   try {
      const headers = {};
      const token = getAccessToken();
      if (token) {
         headers.Authorization = `Bearer ${token}`;
      }
      const response = await axiosBasicInstance.post(`/signup-business`, data, { headers });
      return response;
   } catch (error) {
      throw error;
   }
};

export { googleSignup, normalSignup, signupBusiness };
